<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/mago-university/mago-university']">
    <span translate>MENU.UNIVERSITY</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>Richiedi corso</span>
</div>

<tb-header specificTitle="Richiesta Area Formazione" parentPage="productsdownload"></tb-header>
<div class="contentGlobal" *ngIf="!isLoading">

  <mat-card class="fuse-card-xlarge form-card">
    <mat-card-header>
      <mat-card-title translate style="margin-bottom: 1.4rem">Richiesta Area Formazione</mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <form #trainingRequestForm="ngForm">
      
        <mat-form-field appearance="outline">
          <mat-label translate>Richiesta</mat-label>
          <input required disabled #companyName="ngModel" matInput [(ngModel)]="contact.CompanyName" name="CompanyName" type="text">
          <mat-hint *ngIf="!companyName.valid && companyName.touched">
            <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label translate>Destinatario formazione</mat-label>
          <mat-select required #requestForReq="ngModel" [(ngModel)]="contact.RequestFor" name="RequestFor">
            <mat-option [value]="contact.CompanyName">{{ contact.CompanyName }}</mat-option>
            <mat-option *ngFor="let customer of myCustomers" [value]="customer.CompanyName">{{ customer.CompanyName }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="!requestForReq.valid && requestForReq.touched">
            <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label translate>Modalità</mat-label>
          <mat-select required #typeReq="ngModel" [(ngModel)]="contact.TrainingType.Type" name="Type">
            <mat-option *ngFor="let trainingType of getTrainingTypes()" [value]="trainingType">{{ trainingType }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="!typeReq.valid && typeReq.touched">
            <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
          </mat-hint>
        </mat-form-field>

        <div *ngIf="contact.TrainingType.Type == 'Altro'">
          <mat-form-field appearance="outline">
            <mat-label translate>Dettagli</mat-label>
            <textarea required matInput #typeDetailsReq="ngModel" [(ngModel)]="contact.TrainingType.Details" name="Details"></textarea>
            <mat-hint *ngIf="!typeDetailsReq.valid && typeDetailsReq.touched">
              <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
            </mat-hint>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label translate>Macro Area</mat-label>
          <mat-select multiple (ngModelChange)="setAvailableEnvironments($event)" required #macroAreaReq="ngModel" [(ngModel)]="contact.FunctionalArea" name="FunctionalArea">
            <mat-option *ngFor="let macroArea of macroAreaEnvironments" [value]="macroArea.MacroArea">{{ macroArea.MacroArea != '' ? macroArea.MacroArea : 'Default' }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="!macroAreaReq.valid && macroAreaReq.touched">
            <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label translate>Ambiente</mat-label>
          <mat-select [disabled]="availableEnvironments.length == 0" required multiple #environmentReq="ngModel" [(ngModel)]="contact.Environment" name="Environment">
            <mat-option *ngFor="let environment of availableEnvironments" [value]="environment">{{ environment }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="!environmentReq.valid && environmentReq.touched">
            <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label translate>Richiesta</mat-label>
          <textarea matInput #request="ngModel" matInput required [(ngModel)]="contact.Request" name="Request"></textarea>
          <mat-hint *ngIf="!request.valid && request.touched">
            <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
          </mat-hint>
        </mat-form-field>

      </form>

    </mat-card-content>

    <mat-card-actions>
      <div class="divCardActionRow">
        <button mat-flat-button type="reset" class="left" color="primary" (click)="initializeForm()">
          <span translate>COMMONS.CANCEL</span>
        </button>
        <button mat-flat-button color="primary" (click)="SendRequest()" [disabled]="trainingRequestForm.invalid">
          <span translate>MAIL.COMMONS.SEND</span>
        </button>
      </div>
    </mat-card-actions>

  </mat-card>
</div>

<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>